'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height:30px;\n  line-height: 30px; \n  margin: 0; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n'], ['\n  height:30px;\n  line-height: 30px; \n  margin: 0; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color:', ';\n  color : ', ';\n  height:30px;\n  line-height: 30px; \n  margin: 0;\n'], ['\n  background-color:', ';\n  color : ', ';\n  height:30px;\n  line-height: 30px; \n  margin: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #b8c2cb;\n  font-weight: 600;\n  margin: 0;\n'], ['\n  color: #b8c2cb;\n  font-weight: 600;\n  margin: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width:100%;\n  text-align : left;\n'], ['\n  width:100%;\n  text-align : left;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Wrapper = require('./Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Span = require('./Span');

var _Span2 = _interopRequireDefault(_Span);

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DSpan = _Span2.default.extend(_templateObject, function (props) {
  return props.isMax || props.isMin ? 'none' : 'auto';
}, function (props) {
  return props.isMax || props.isMin ? 'default' : 'pointer';
}, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#fff';
});
var SelectedSpan = _Span2.default.extend(_templateObject2, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#00b9f5';
}, function (props) {
  return props.isMax || props.isMin ? '#000' : 'white';
});
var HeadSpan = _Span2.default.extend(_templateObject3);
var Body = _styledComponents2.default.div(_templateObject4);

var DateView = function DateView(props) {
  var date = props.date,
      format = props.format,
      onDateChange = props.onDateChange,
      maxDate = props.maxDate,
      minDate = props.minDate;

  var mainDate = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY') : (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
  var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
  var currentDate = mainDate.get('date');
  var days = mainDate.daysInMonth(5);
  var daysToAdd = mainDate.startOf('month').format('e');
  var daysArray = [];
  for (var i = 1; i <= days; i++) {
    daysArray[i - 1] = {
      d: i,
      isMax: endDate ? mainDate.startOf('day').date(i).isAfter(endDate) : false,
      isMin: startDate ? mainDate.startOf('day').date(i).isBefore(startDate) : false
    };
  }
  var extraDaysArray = [];
  for (var _i = 0; _i < daysToAdd; _i++) {
    extraDaysArray[_i] = 0;
  }
  var totalDays = extraDaysArray.concat(daysArray);
  var d = [];
  var chunk = 7;
  for (var _i2 = 0, j = totalDays.length; _i2 < j; _i2 += chunk) {
    d.push(totalDays.slice(_i2, _i2 + chunk));
  }
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Header2.default,
      null,
      _react2.default.createElement(
        HeadSpan,
        null,
        'S'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'M'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'T'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'W'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'T'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'F'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'S'
      )
    ),
    d.map(function (week, k) {
      return _react2.default.createElement(
        Body,
        { key: k },
        week.map(function (day, i) {
          return currentDate === day.d && !d.isMax ? _react2.default.createElement(
            SelectedSpan,
            {
              isMax: day.isMax,
              isMin: day.isMin,
              key: i,
              onClick: function onClick() {
                return !d.isMax && !day.isMin && onDateChange(day.d);
              }
            },
            day ? day.d : ''
          ) : _react2.default.createElement(
            DSpan,
            {
              isMax: day.isMax,
              isMin: day.isMin,
              key: i,
              onClick: function onClick() {
                return !d.isMax && !day.isMin && onDateChange(day.d);
              }
            },
            day ? day.d : ''
          );
        })
      );
    })
  );
};

DateView.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onDateChange: _propTypes2.default.func
};
exports.default = DateView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/DateView.js
// module id = 486
// module chunks = 0